import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const SAME_PAGE_INDEX = [
  /**
   * 예전에 url은 다르지만 사실 같은 페이지인 상황이 있었기에 구현한 코드.
   * 지금은 의미없지만 재사용 가능해서 냅둠.
   * */
  { path: "/search", type: "exploreGrp" }
  /**
   * 하단 코드는 예전 랭크 화면과 검색 화면을 같은 페이지에서 띄우던 시절
   * 이렇게 사용했다 남긴 샘플코드
   */
  // { path: "/rank", type: "exploreGrp" }
];

/**
 *
 * 브라우저에서 페이지 이동시 새 화면의 경우 전 화면의 스크롤위치가 아닌 최상단으로 이동되도록 하는 코드.
 * import ScrollMemory from "react-router-scroll-memory";
 * 상단 npm 라이브러리 사용중이였으나, react-router-dom v6 에 호환되지 않아 새로만듦.
 *
 */

function ScrollToTop(props) {
  const [lastPathname, setLastPathname] = useState(null);

  const location = useLocation();
  useEffect(() => {
    if (!isSamePage()) {
      window.scrollTo(0, 0);
    }
    setLastPathname(location.pathname);
  }, [location]);

  const isSamePage = () => {
    const nowPathname = location.pathname;
    let lastGrp = lastPathname;
    let nowGrp = nowPathname;

    for (let i = 0; i < SAME_PAGE_INDEX.length; i++) {
      const element = SAME_PAGE_INDEX[i];
      if (lastGrp === element.path) lastGrp = element.type;
      if (nowGrp === element.path) nowGrp = element.type;
    }

    if (nowGrp !== lastGrp) {
      return false;
    }
    return true;
  };

  return <div>{props.children}</div>;
}

export default ScrollToTop;
